import { createFileRoute } from "@tanstack/react-router";
import type { FC } from "react";
import { Page404 } from "../../../../components/templates/Page404";

const NotFound: FC = () => {
  return <Page404 />;
};

export const Route = createFileRoute("/_private/_errors/not_found/")({
  component: NotFound,
});
